import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogSize: {
      minWidth: '450px',
      minHeight: '146px',
    },
    backdrop: {
      color: legacyColors.white,
      zIndex: theme.zIndex.drawer + 1,
    },
  };
};
